<template>
    <form-accordion
        name="seller-information"
        section="Seller Information"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <property-address
            :property="property"
            :read_only="read_only"
        />

        <seller-1
            :deal="property.deal"
            :contact="contacts_seller_1"
            :property="property"
            :read_only="read_only"
        />

        <seller-2
            :deal="property.deal"
            :contact="contacts_seller_2"
            :read_only="read_only"
        />

        <attorney
            :contact="contacts_seller_attorney"
            :available_contacts="available_contacts"
            :read_only="read_only"
        />

        <lawyers-sent-info
            :deal="property.deal"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import PropertyAddress from './property-address.vue';
import Seller1 from './seller-1.vue';
import Seller2 from './seller-2.vue';
import Attorney from './attorney.vue';
import LawyersSentInfo from './lawyers-sent-info.vue';

export default {
    components: {
        PropertyAddress,
        Seller1,
        Seller2,
        Attorney,
        LawyersSentInfo,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        contacts_seller_1: { default: () => ({}) },
        contacts_seller_2: { default: () => ({}) },
        contacts_seller_attorney: { default: () => ({}) },
        read_only: { default: false },
        available_contacts: { default: () => [] },
    },
}
</script>
